import { ReactNode } from 'react';

import { Box } from '../../../components/MuiGenerals';

const FilterTableLayoutContainer = ({ children }: { children: ReactNode }) => {
  return <Box>{children}</Box>;
};

export default FilterTableLayoutContainer;
